module.exports = __webpack_public_path__ + "static/media/Natalie-Prychitko.cd4c1a22.png";